'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherClock, FeatherExternalLink, FeatherLoader } from '@subframe/core';
import { Button } from '@/shared/components/ui';
import type { UseNegociacaoSelfReturn } from '../hooks';
import { urlPagamentoSegura } from '@/shared/utils/pagamentoUrl';
import { SimpleLogoHeader } from './SimpleLogoHeader';
interface WaitingPaymentScreenProps {
  vm: UseNegociacaoSelfReturn;
}
export const WaitingPaymentScreen = t0 => {
  const $ = _c(28);
  const {
    vm
  } = t0;
  const invoiceUrl = urlPagamentoSegura(vm.invoiceUrl) ? vm.invoiceUrl : null;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SimpleLogoHeader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-brand-50 flex h-16 w-16 items-center justify-center rounded-full"><FeatherClock className="text-brand-600 h-7 w-7" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex max-w-[460px] flex-col items-center gap-2 text-center"><h1 className="text-heading-dark text-xl font-semibold sm:text-[26px]">Aguardando confirmação do pagamento</h1><p className="text-label-muted text-sm leading-relaxed">Você foi redirecionado para finalizar o pagamento. Assim que confirmado, seu agente estará pronto para negociar por você.</p></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== vm.pollingPagamentoExpirado) {
    t4 = !vm.pollingPagamentoExpirado && <FeatherLoader className="h-4.5 w-4.5 flex-none animate-spin text-neutral-500" />;
    $[3] = vm.pollingPagamentoExpirado;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = vm.pollingPagamentoExpirado ? "Ainda sem confirma\xE7\xE3o do pagamento" : "Pagamento em processamento";
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="text-heading-dark text-[13px] font-semibold">{t5}</div>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = vm.pollingPagamentoExpirado ? "Paramos de verificar automaticamente. Verifique novamente quando quiser." : "Processaremos assim que poss\xEDvel. A confirma\xE7\xE3o pode levar alguns instantes.";
  let t8;
  if ($[7] !== t7) {
    t8 = <div className="text-xs text-neutral-500">{t7}</div>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t6 || $[10] !== t8) {
    t9 = <div>{t6}{t8}</div>;
    $[9] = t6;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t4 || $[13] !== t9) {
    t10 = <div aria-live="polite" className="flex max-w-[420px] items-center gap-3 rounded-[10px] border border-solid border-neutral-200 px-4.5 py-3.5">{t4}{t9}</div>;
    $[12] = t4;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== vm.pollingPagamentoExpirado || $[16] !== vm.verificarPagamentoAgora) {
    t11 = vm.pollingPagamentoExpirado && <Button size="small" variant="neutral-secondary" onClick={vm.verificarPagamentoAgora}>Verificar novamente</Button>;
    $[15] = vm.pollingPagamentoExpirado;
    $[16] = vm.verificarPagamentoAgora;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== invoiceUrl) {
    t12 = invoiceUrl && <Button size="small" iconRight={<FeatherExternalLink />} onClick={() => window.open(invoiceUrl, "_blank", "noopener,noreferrer")}>Abrir página de pagamento</Button>;
    $[18] = invoiceUrl;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== vm.planoResumoLabel) {
    t13 = <span className="mt-4 text-[13px] text-neutral-500">{vm.planoResumoLabel}</span>;
    $[20] = vm.planoResumoLabel;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <a href="mailto:suporte@arbitralis.com.br?subject=Problema%20com%20o%20pagamento" className="text-brand-600 text-[13px] font-semibold underline">Estou com problema no pagamento</a>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t12 || $[26] !== t13) {
    t15 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}<div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 py-12">{t2}{t3}{t10}{t11}{t12}{t13}{t14}</div></div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
};